import { cx, css } from '@linaria/core';
import { styled } from '@linaria/react';
import { flex, theming, breakpoints } from 'styles/utils';
import { base } from 'styles/variables';
export const SIDEBAR_SECTIONS_GAP = '1rem';
export const appContainer = "odules__Sidebar__Sidebar_styles_ts-appContainer-asa6cro";
export const CircularButton = /*#__PURE__*/styled("button")({
  name: "CircularButton",
  class: "odules__Sidebar__Sidebar_styles_ts-CircularButton-c27n4g2"
});
export const appInfoArea = cx("odules__Sidebar__Sidebar_styles_ts-appInfoArea-amaz8vj", flex.init, flex.alignItems.center);
export const listWithGap = cx("odules__Sidebar__Sidebar_styles_ts-listWithGap-ljeirct", flex.init, flex.direction.column);
export const sidebarWrapper = cx("odules__Sidebar__Sidebar_styles_ts-sidebarWrapper-so9vy5c", listWithGap);
export const mobileSidebar = cx("odules__Sidebar__Sidebar_styles_ts-mobileSidebar-mogebx2", flex.init, flex.alignItems.center);
export const mobilePopoverStyles = "odules__Sidebar__Sidebar_styles_ts-mobilePopoverStyles-m2pql3t";
export const sidebarScrollableContainer = "odules__Sidebar__Sidebar_styles_ts-sidebarScrollableContainer-sjvjtj8";
export const motionMenuIcon = "odules__Sidebar__Sidebar_styles_ts-motionMenuIcon-m1p0p1ta";
export const mobileMenu = "odules__Sidebar__Sidebar_styles_ts-mobileMenu-mi6sxnu";
export const submenuIcon = "odules__Sidebar__Sidebar_styles_ts-submenuIcon-s12jwtr2";
export const shrinkText = "odules__Sidebar__Sidebar_styles_ts-shrinkText-s1a8xmdc";
export const appNameArea = "odules__Sidebar__Sidebar_styles_ts-appNameArea-aexlod4";
export const userArea = "odules__Sidebar__Sidebar_styles_ts-userArea-u18l8aq3";
export const intersectionDetecterDiv = "odules__Sidebar__Sidebar_styles_ts-intersectionDetecterDiv-i1jnsjwf";
export const isNotCollapsedSticky = "odules__Sidebar__Sidebar_styles_ts-isNotCollapsedSticky-i1l3vyqx";
export const isCollapsedSticky = "odules__Sidebar__Sidebar_styles_ts-isCollapsedSticky-icrczd6";
export const isNotSticky = "odules__Sidebar__Sidebar_styles_ts-isNotSticky-ir0024v";

require("./Sidebar.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Sidebar.styles.ts");